module.exports = __webpack_public_path__ + "static/media/styledComponents.924041ba.png";